import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    FormGroup,
    Label,
} from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Link } from "react-router-dom";

export default function Allcategory() {
    const API_URL = process.env.REACT_APP_APIURL;

    const breadcrumbItems = [
        { title: "HOME", link: "/" },
        { title: "All Category", link: "#" },
    ];

    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Delete modal state
    const [deleteId, setDeleteId] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    // Edit modal state
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [editValue, setEditValue] = useState("");

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const response = await fetch(`${`https://api.myhappywheels.com/api`}/category`);

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const data = await response.json();
                setCategory(data.allCategory);
            } catch (err) {
                console.error("Error fetching categories:", err);
                setError("Failed to fetch categories");
            } finally {
                setLoading(false);
            }
        };

        fetchCategory();
    }, [API_URL]);

    // Delete
    const confirmDelete = (id) => {
        setDeleteId(id);
        setDeleteModalOpen(true);
    };

    const handleDelete = async () => {
        try {
            const response = await fetch(`${API_URL}/category/${deleteId}`)

            if (!response.ok) throw new Error("Failed to delete category");

            setCategory((prev) => prev.filter((item) => item._id !== deleteId));
            setDeleteModalOpen(false);
            setDeleteId(null);
        } catch (err) {
            console.error("Delete error:", err);
            alert("Error deleting category.");
        }
    };

    const handleCancelDelete = () => {
        setDeleteId(null);
        setDeleteModalOpen(false);
    };

    // Edit
    const openEditModal = (id, currentValue) => {
        setEditId(id);
        setEditValue(currentValue);
        setEditModalOpen(true);
    };

    const handleEditSubmit = async () => {
        try {
            const response = await fetch(`${API_URL}/category/${editId}`, {
                method: "PUT", // or PATCH based on your backend
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ category: editValue }),
            });

            if (!response.ok) throw new Error("Failed to update category");

            // Update local list
            setCategory((prev) =>
                prev.map((item) =>
                    item._id === editId ? { ...item, category: editValue } : item
                )
            );

            setEditId(null);
            setEditValue("");
            setEditModalOpen(false);
        } catch (err) {
            console.error("Edit error:", err);
            alert("Error updating category.");
        }
    };

    const handleCancelEdit = () => {
        setEditId(null);
        setEditValue("");
        setEditModalOpen(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="AllCategory"
                        breadcrumbItems={breadcrumbItems}
                    />
                    <Card>
                        <CardBody>
                            <div className="table-responsive">
                                <table className="table table-centered align-middle table-nowrap mb-0 table-bordered">
                                    <thead className="table-light text-muted">
                                        <tr>
                                            <th>ID</th>
                                            <th>Category</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {category && category.length > 0 ? (
                                            category.map((cat, index) => (
                                                <tr key={cat._id}>
                                                    <td>{index + 1}</td>
                                                    <td>{cat.category}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-light me-2"
                                                            onClick={() => openEditModal(cat._id, cat.category)}
                                                        >
                                                            <i className="mdi mdi-pencil text-primary font-size-18"></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-light"
                                                            onClick={() => confirmDelete(cat._id)}
                                                        >
                                                            <i className="mdi mdi-trash-can text-danger font-size-18"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    {loading ? "Loading..." : "No categories found."}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Container>

                {/* Delete Modal */}
                <Modal isOpen={deleteModalOpen} toggle={handleCancelDelete}>
                    <ModalHeader toggle={handleCancelDelete}>Confirm Deletion</ModalHeader>
                    <ModalBody>Are you sure you want to delete this category?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={handleDelete}>
                            Yes, Delete
                        </Button>
                        <Button color="secondary" onClick={handleCancelDelete}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Edit Modal */}
                <Modal isOpen={editModalOpen} toggle={handleCancelEdit}>
                    <ModalHeader toggle={handleCancelEdit}>Edit Category</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="categoryInput">Category Name</Label>
                            <Input
                                type="text"
                                id="categoryInput"
                                value={editValue}
                                onChange={(e) => setEditValue(e.target.value)}
                                placeholder="Enter category name"
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleEditSubmit}>
                            Save Changes
                        </Button>
                        <Button color="secondary" onClick={handleCancelEdit}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    );
}
